import angular from 'angular'
import { EditLeadOfficeTeamComponent } from './edit-lead-office-team.component';
import { LeadOfficeTeamListComponent } from './lead-office-team-list.component';

export const LeadOfficeTeamModule = angular
    .module("apex.mainApp.leads.officeTeam", [])
    .component("apexEditLeadOfficeTeam", EditLeadOfficeTeamComponent)
    .component("apexLeadOfficeTeamList", LeadOfficeTeamListComponent)
    .name;
